// 会話場面 (ADV) の効果音 (2026-10-27・音の専用セッション)。台本の `cue` に `sfx:adv_<名前>` と書くと鳴る (game.ts advCueSfx)。
//   ユーザー原文 (10-27)「エフェクトとかの表現はいい感じ。効果音が安っぽく感じるかな」 → 合成の仮の音でなく ElevenLabs の素材で作った。
//   素材 = scripts/render_adv_sfx.py (記録 = docs/research/2026-10-27-adv-sfx.md)。大きさは WAV に焼いた (戦いの音より控えめ) ので、鳴らす大きさは薙ぎと同じ 0.2。
//   既定 = 本命 (配布版・public/sfx/adv_<名前>.wav。10-27 に作者が聞き比べで選んだ案で、名前ごとに a〜c のどれか = render_adv_sfx.py の SOUNDS)。
//   開発版 ?advSound=b|c = その案の書き出し (public/sfx/candidates/・git 外)。
//   URL は game.ts の DEV の箱の中でだけ読む。
import type { SfxId } from './types'

export const ADV_SOUND_NAMES = ['chair_pull', 'rustle', 'chair_scrape', 'cloth_pull', 'wrist_grip',
  'hound_door', 'hound_hall_air', 'hound_chain_small', 'hound_chain_drag', 'hound_chain_crown', 'hound_rumble',
  'hound_rise', 'hound_footstep', 'hound_chain_taut', 'hound_battle_fade', 'hound_crown_place',
  // 10-28 部屋の空気 (amb: でループ)・介錯・鶏・剣舞・先代の場面の物音 (docs/research/2026-10-28-adv-sound-bed.md)
  'bride_hall_air', 'exec_hall_air', 'jester_wind', 'blade_theater', 'princess_stage_air', 'princess_hum',
  'exec_door', 'exec_paper_flip', 'exec_robe', 'exec_paper_turn', 'exec_paper_fold', 'exec_blade_swish',
  'exec_blade_ring', 'exec_stomp', 'exec_battle_fade', 'exec_paper_floor', 'exec_paper_open', 'exec_blade_floor',
  'jester_steps_stop', 'jester_rope_creak', 'jester_footstep', 'jester_feathers', 'jester_bell_hum',
  'jester_wings_spread', 'jester_wing_beat', 'jester_battle_fade', 'jester_rope_rub',
  'blade_curtain', 'blade_hem', 'blade_step', 'blade_rustle', 'blade_stomp', 'blade_whoosh', 'blade_drop', 'blade_echo', 'blade_clap',
  'princess_corridor_step', 'princess_door', 'princess_step', 'princess_twirl', 'princess_grip',
  'princess_draw', 'princess_lunge', 'princess_shards', 'princess_tiara',
  // 10-28 夕 近衛騎士・覚醒獣 (借り物を専用に・docs/research/2026-10-28-adv-sound-knight-awoken.md)
  'knight_hall_air', 'knight_battle_fade', 'knight_footstep', 'knight_lance_fall', 'knight_chain_drop', 'knight_door', 'knight_armor_collapse',
  'awoken_hall_air', 'awoken_battle_fade', 'awoken_claw_scrape', 'awoken_drag', 'awoken_lay_down', 'awoken_crown_creak',
  'awoken_chain', 'awoken_crouch', 'awoken_stones_fall', 'awoken_chain_hold', 'awoken_chain_release',
  // 10-28 夜 騎士の石突きが床を打つ (光る所に音・docs/research/2026-10-28-adv-no-bgm-cut-knight-fixes.md)
  'knight_butt_strike',
  // 10-30 プロローグ (砂嵐・錠・吹き出し・月が回る間・紙がめくれる・握り＝docs/research/2026-10-30-prologue-sfx.md)
  'prologue_static', 'prologue_lock', 'prologue_bubble', 'prologue_bubble2', 'prologue_ages', 'prologue_peel', 'prologue_grip'] as const
export type AdvSoundName = typeof ADV_SOUND_NAMES[number]
export const ADV_SFX_IDS = ADV_SOUND_NAMES.map(n => `adv_${n}` as const)

export type AdvSoundTake = 'a' | 'b' | 'c'
let take: AdvSoundTake = 'a'
export function setAdvSoundTake(value: string | null | undefined): AdvSoundTake {
  take = value === 'b' || value === 'c' ? value : 'a'
  // 別案は開発版でこの時だけ読む (audio.ts は重いので後から読む)。
  if (take !== 'a' && typeof fetch !== 'undefined') void import('./audio').then(m => m.preloadAdvSoundTake(take))
  return take
}
export function advSoundTake(): AdvSoundTake { return take }

/** 先読みする素材 [キー, URL]。本命のキー = 効果音の名前・別案のキー = <名前>_<案> (読めていればカタログが先に鳴らす)。 */
export function advSoundFiles(which: AdvSoundTake): [string, string][] {
  return ADV_SOUND_NAMES.map(n => which === 'a'
    ? [`adv_${n}`, `/sfx/adv_${n}.wav?v=1`]
    : [`adv_${n}_${which}`, `/sfx/candidates/adv_${n}_${which}.wav?v=1`])
}

/** カタログの samples: 別案 (選んだ時だけ読まれる) を先に試し、無ければ本命。 */
export function advSoundSamples(id: SfxId): string[] {
  return [`${id}_b`, `${id}_c`, id]
}
